import { Action, EventType } from '../../graphql/graphql';
import { MetadataMessage } from './MetadataMessage';
import React from 'react';
import { log } from '../../lib/logger';
export const isActionEvent = (event) => {
    return event.type === EventType.Action && event.actionEvent !== null;
};
export const ActionMessage = ({ event }) => {
    var _a, _b, _c;
    switch ((_a = event.actionEvent) === null || _a === void 0 ? void 0 : _a.action) {
        case Action.Assigned:
            return React.createElement(MetadataMessage, { text: (_b = event.actionEvent) === null || _b === void 0 ? void 0 : _b.remarks });
        case Action.Queued:
            return React.createElement(MetadataMessage, { text: (_c = event.actionEvent) === null || _c === void 0 ? void 0 : _c.remarks });
        default:
            log.warn('Unimplemented Action Message type', event);
            return null;
    }
};
